var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContracts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 220,
    viewBox: "0 0 200 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H176C189.255 0 200 10.7452 200 24V196C200 209.255 189.255 220 176 220H24C10.7452 220 0 209.255 0 196V24Z",
    fill: "#5C6FCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.415 141.516C123.415 144.237 121.208 146.444 118.486 146.444H82.3436C79.6216 146.444 77.415 144.237 77.415 141.516V105.373C77.415 102.651 79.6216 100.444 82.3436 100.444H118.486C121.208 100.444 123.415 102.651 123.415 105.373V141.516Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7134 144.065C70.7134 145.233 69.7668 146.179 68.5992 146.179H53.0952C51.9275 146.179 50.981 145.233 50.981 144.065V128.561C50.981 127.394 51.9275 126.447 53.0952 126.447H68.5992C69.7668 126.447 70.7134 127.394 70.7134 128.561V144.065Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8957 118.331C70.8957 119.523 69.9294 120.489 68.7374 120.489H52.9104C51.7184 120.489 50.7522 119.523 50.7522 118.331V102.504C50.7522 101.312 51.7184 100.346 52.9104 100.346H68.7374C69.9294 100.346 70.8957 101.312 70.8957 102.504V118.331ZM96.7944 92.4322C96.7944 93.6242 95.8282 94.5905 94.6362 94.5905H78.8092C77.6172 94.5905 76.6509 93.6242 76.6509 92.4322V76.6052C76.6509 75.4133 77.6172 74.447 78.8092 74.447H94.6362C95.8282 74.447 96.7944 75.4133 96.7944 76.6052V92.4322Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M68.7368 94.5906C69.9287 94.5906 70.895 93.6243 70.895 92.4323V76.6053C70.895 75.4134 69.9287 74.4471 68.7368 74.4471H52.9098C51.7178 74.4471 50.7515 75.4134 50.7515 76.6053V92.4323C50.7515 93.6243 51.7178 94.5906 52.9098 94.5906H68.7368Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.761 94.59C104.569 94.59 103.603 93.6237 103.603 92.4318V76.6047C103.603 75.4128 104.569 74.4465 105.761 74.4465H121.588C122.78 74.4465 123.747 75.4128 123.747 76.6047V92.4318C123.747 93.6237 122.78 94.59 121.588 94.59H105.761ZM131.66 120.489C130.468 120.489 129.502 119.522 129.502 118.331V102.504C129.502 101.312 130.468 100.345 131.66 100.345H147.487C148.679 100.345 149.645 101.312 149.645 102.504V118.331C149.645 119.522 148.679 120.489 147.487 120.489H131.66ZM129.502 92.4318C129.502 93.6237 130.468 94.59 131.66 94.59H147.487C148.679 94.59 149.645 93.6237 149.645 92.4318V76.6047C149.645 75.4128 148.679 74.4465 147.487 74.4465H131.66C130.468 74.4465 129.502 75.4128 129.502 76.6047V92.4318Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.572 146.591C130.38 146.591 129.414 145.624 129.414 144.432V128.605C129.414 127.413 130.38 126.447 131.572 126.447H147.399C148.591 126.447 149.557 127.413 149.557 128.605V144.432C149.557 145.624 148.591 146.591 147.399 146.591H131.572Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContracts);
export default __webpack_public_path__ + "static/media/contracts.ded02269.svg";
export { ForwardRef as ReactComponent };